import { Link } from 'react-router-dom';
import { EGRAHMANTREE_URL, FLAGSHIP, SITE } from '../config/site';

export default function CtaBand({
  creative = false,
  title = SITE.brandTagline,
  description = `Explore ${FLAGSHIP.name} or partner with us on software, AI, GenAI, and agentic AI.`,
  primaryLabel = `Visit ${FLAGSHIP.domain}`,
  primaryHref = EGRAHMANTREE_URL,
  primaryExternal = true,
  secondaryLabel = 'Contact us',
  secondaryTo = '/contact',
}) {
  return (
    <section className={`cta-band${creative ? ' cta-band--creative' : ''}`}>
      <div className="container cta-band__inner">
        <div className="cta-band__content">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div className="cta-band__actions">
          {primaryExternal ? (
            <a
              href={primaryHref}
              className={`btn${creative ? ' btn--primary' : ' btn--white'}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {primaryLabel}
            </a>
          ) : (
            <Link to={primaryHref} className={`btn${creative ? ' btn--primary' : ' btn--white'}`}>
              {primaryLabel}
            </Link>
          )}
          <Link to={secondaryTo} className="btn btn--ghost">
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
